/*
 * Deletes a catalog type from API and removes it in the vuex store
 *
 * Usage: catalogService.delete('highway')
 *          .then(=> ...)
 */

import Vue from 'vue'
import store from '../../../store'

const success = function (payload) {
  store.dispatch('catalogs/delete', payload)
}

const failure = function (payload) {
}

const deleteFromSource = function (source, data) {
  const index = source.indexOf(data)

  if (index === -1) {
    return
  }
  source.splice(index, 1)
}

export default (catalog, payload, options = {}) => {
  const source = options.source

  return Vue.$http.delete(`/${catalog}/${payload.id}/`, payload)
  .then((response) => {
    if (source) {
      deleteFromSource(source, payload)
    }
    return response
  })
  .catch((error) => {
    failure(error)
    throw error
  })
}


// WEBPACK FOOTER //
// ./src/services/purchase/warehouse/delete.js